import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    dashboardCard: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
}));
